import { render, staticRenderFns } from "./date.vue?vue&type=template&id=2603a7d1&lang=pug&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"
import style0 from "./date.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2603a7d1')) {
      api.createRecord('2603a7d1', component.options)
    } else {
      api.reload('2603a7d1', component.options)
    }
    module.hot.accept("./date.vue?vue&type=template&id=2603a7d1&lang=pug&", function () {
      api.rerender('2603a7d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/date.vue"
export default component.exports